import script from "./EditPostModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditPostModal.vue?vue&type=script&lang=ts&setup=true"

import "./EditPostModal.vue?vue&type=style&index=0&id=cf9e88e2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf9e88e2"]])

export default __exports__